import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ModalLayout from '../layouts/ModalLayout';
import CancelSaveButton from '../misc/CancelSaveButton';

interface SetMemberInactiveModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onConfirm: (inactiveReason?: string) => void;
  memberName: string;
}

export default function SetMemberInactiveModal({
  open,
  setOpen,
  onConfirm,
  memberName,
}: SetMemberInactiveModalProps): JSX.Element {
  const [inactiveReason, setInactiveReason] = useState<string>('');
  const { t } = useTranslation();

  const handleSubmit = () => {
    onConfirm(inactiveReason.trim() || undefined);
    setOpen(false);
    setInactiveReason('');
  };

  const handleCancel = () => {
    setOpen(false);
    setInactiveReason('');
  };

  return (
    <ModalLayout
      open={open}
      setOpen={setOpen}
      className="relative transform overflow-hidden rounded-[12px] bg-secondary-50 px-6 py-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
      <div className="mb-4 flex flex-col gap-4">
        <h3 className="text-xl font-semibold">
          {t('component.modal.setMemberInactive.title', { memberName })}
        </h3>       
        <div className="flex flex-col gap-2">
          <label htmlFor="inactiveReason" className="text-sm font-medium">
            {t('component.modal.setMemberInactive.reasonLabel')} ({t('general.optional')})
          </label>
          <textarea
            id="inactiveReason"
            className="h-24 w-full resize-none rounded-lg border border-gray-300 p-2 placeholder-gray-400 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500"
            placeholder={t('component.modal.setMemberInactive.reasonPlaceholder')}
            value={inactiveReason}
            onChange={(e) => setInactiveReason(e.target.value)}
          />
        </div>
      </div>
      
      <div className="flex justify-end">
        <CancelSaveButton
          onCancel={handleCancel}
          onSave={handleSubmit}
          buttonText={t('component.modal.setMemberInactive.confirmButton')}
        />
      </div>
    </ModalLayout>
  );
}
